module.exports = __webpack_public_path__ + "img/history-header_sp.png";